import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ScrollToTop } from './components/ScrollToTop';
// Lazy load pages for better performance
const LandingPage = lazy(() => import('./pages/LandingPage').then(module => ({
  default: module.LandingPage
})));
const AboutPage = lazy(() => import('./pages/AboutPage').then(module => ({
  default: module.AboutPage
})));
const ProjectsPage = lazy(() => import('./pages/ProjectsPage').then(module => ({
  default: module.ProjectsPage
})));
const AdminPage = lazy(() => import('./pages/AdminPage').then(module => ({
  default: module.AdminPage
})));
// Loading component
function PageLoader() {
  return <div className="min-h-screen flex items-center justify-center bg-gray-50" data-id="element-0">
      <div className="text-center" data-id="element-1">
        <div className="inline-block h-12 w-12 animate-spin rounded-full border-4 border-solid border-blue-600 border-r-transparent mb-4" data-id="element-2"></div>
        <p className="text-gray-600 font-medium" data-id="element-3">Cargando...</p>
      </div>
    </div>;
}
export function App() {
  return <BrowserRouter data-id="element-4">
      <ScrollToTop data-id="element-5" />
      <Suspense fallback={<PageLoader data-id="element-7" />} data-id="element-6">
        <Routes data-id="element-8">
          <Route path="/" element={<LandingPage data-id="element-10" />} data-id="element-9" />
          <Route path="/quienes-somos" element={<AboutPage data-id="element-12" />} data-id="element-11" />
          <Route path="/proyectos" element={<ProjectsPage data-id="element-14" />} data-id="element-13" />
          <Route path="/admin" element={<AdminPage data-id="element-16" />} data-id="element-15" />
        </Routes>
      </Suspense>
    </BrowserRouter>;
}